{
  "actionbar.actions": "Действия",
  "actionbar.actionsAvailable": "Возможно выполнение действий.",
  "actionbar.clearSelection": "Очистить выбор",
  "actionbar.selected": "Выбрано: {count}",
  "actionbar.selectedAll": "Выбрано все",
  "button.pending": "в ожидании",
  "contextualhelp.help": "Справка",
  "contextualhelp.info": "Информация",
  "dialog.alert": "Предупреждение",
  "dialog.dismiss": "Пропустить",
  "dropzone.replaceMessage": "Перетащите файл для замены",
  "inlinealert.informative": "Информация",
  "inlinealert.negative": "Ошибка",
  "inlinealert.notice": "Предупреждение",
  "inlinealert.positive": "Успешно",
  "label.(optional)": "(дополнительно)",
  "label.(required)": "(обязательно)",
  "menu.moreActions": "Дополнительные действия",
  "picker.placeholder": "Выбрать…",
  "slider.maximum": "Максимум",
  "slider.minimum": "Минимум",
  "table.loading": "Загрузка...",
  "table.loadingMore": "Дополнительная загрузка...",
  "table.resizeColumn": "Изменить размер столбца",
  "table.sortAscending": "Сортировать по возрастанию",
  "table.sortDescending": "Сортировать по убыванию",
  "tag.actions": "Действия",
  "tag.hideButtonLabel": "Показать меньше",
  "tag.noTags": "Нет",
  "tag.showAllButtonLabel": "Показать все ({tagCount, number})",
  "breadcrumbs.more": "Дополнительные элементы"
}